import styles from './gpt-overview.module.scss';
import { useState } from 'react';
import { useGetRequestNewHook } from '../requestUtils';
import { Col, Row } from 'reactstrap';
import PageTitle from '../page-title/page-title';
import { Box, Container, Tab, Tabs } from '@frontend-workspace/react-shared-lib';
import GPTDefinitions from '../gpt-definitions/gpt-definitions';
import GPTRouteDefinition from '../gpt-route-definition/gpt-route-definition';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface GPTOverviewProps { }

export function GPTOverview(props: GPTOverviewProps) {
  const { t } = useTranslation();
  const { data, getData } = useGetRequestNewHook(`gpt/definitions`, []);
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const navigateToTabOne = () => setSelectedTab(0);
  const navigateToTabTwo = () => setSelectedTab(1);

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title='GPT' subtitle={`(${t("standard.admin")})`} />
            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '20px' }}>
              <Tabs
                value={selectedTab}
                variant="scrollable"
                scrollButtons="auto">
                <Tab label={t("gptOverview.pages")} onClick={navigateToTabOne} />
                <Tab label={t("gptOverview.functions")} onClick={navigateToTabTwo} />
              </Tabs>
            </Box>
            <div>
              {selectedTab === 0 && <GPTRouteDefinition definitions={data} refresh={getData} />}
              {selectedTab === 1 && <GPTDefinitions definitions={data} refresh={getData} />}
            </div>
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default GPTOverview;
